import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal } from "../site/Reveal";
import { Loader2, Phone, Mail, MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Field = ({ label, children }) => (
  <div>
    <label className="block text-xs font-mono uppercase text-slate-300 mb-2">{label}</label>
    {children}
  </div>
);

const inputCls =
  "w-full bg-slate-900 border border-slate-700 px-4 py-3 text-sm text-white focus:outline-none focus:border-blue-500 font-mono placeholder:text-slate-500";

export const TechContact = () => {
  const [form, setForm] = useState({ organization: "", name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, { ...form, subject: form.organization || "Richiesta preventivo" });
      toast.success("Richiesta inviata. Riscontro entro il giorno lavorativo successivo.");
      setForm({ organization: "", name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("Invio non riuscito. Riprova tra poco.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-24 bg-slate-900 text-white">
      <div className="max-w-4xl mx-auto px-6">
        <Reveal>
          <div className="border border-slate-700 bg-slate-950 p-8 sm:p-12 shadow-2xl">
            <div className="max-w-xl mb-8">
              <span className="text-xs font-mono uppercase tracking-widest text-blue-400">Canale Istituzionale Diretto</span>
              <h2 className="text-3xl font-extrabold uppercase text-white mt-1 mb-2">Contatta la Direzione Saircos</h2>
              <p className="text-xs text-slate-400 font-mono">
                Invia una richiesta di preventivo, un invito a procedura di gara o la richiesta del fascicolo attestazioni.
              </p>
            </div>
            <div className="grid sm:grid-cols-3 gap-4 mb-10 pb-8 border-b border-slate-800">
              <a href="tel:+390282396294" data-testid="contact-phone" className="flex items-center gap-3 group">
                <Phone size={18} className="text-blue-400 shrink-0" />
                <div>
                  <p className="text-[10px] font-mono uppercase tracking-widest text-slate-400">Telefono</p>
                  <p className="text-sm font-bold text-white group-hover:text-blue-400 transition-colors">02 8239 6294</p>
                </div>
              </a>
              <a href="mailto:info@saircos-spa.it" data-testid="contact-email" className="flex items-center gap-3 group">
                <Mail size={18} className="text-blue-400 shrink-0" />
                <div>
                  <p className="text-[10px] font-mono uppercase tracking-widest text-slate-400">Email</p>
                  <p className="text-sm font-bold text-white group-hover:text-blue-400 transition-colors">info@saircos-spa.it</p>
                </div>
              </a>
              <div className="flex items-center gap-3" data-testid="contact-address">
                <MapPin size={18} className="text-blue-400 shrink-0" />
                <div>
                  <p className="text-[10px] font-mono uppercase tracking-widest text-slate-400">Sede operativa</p>
                  <p className="text-sm font-bold text-white">Vicolo San Martino 10, Pero (MI)</p>
                </div>
              </div>
            </div>
            <form onSubmit={submit} data-testid="contact-form" className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <Field label="Ente / Condominio / Committente">
                  <input data-testid="contact-input-organization" type="text" className={inputCls} placeholder="es. Condominio Via Roma 10" value={form.organization} onChange={set("organization")} />
                </Field>
                <Field label="Persona di riferimento *">
                  <input data-testid="contact-input-name" type="text" required className={inputCls} placeholder="Nome e Cognome" value={form.name} onChange={set("name")} />
                </Field>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <Field label="Contatto email / PEC *">
                  <input data-testid="contact-input-email" type="email" required className={inputCls} placeholder="email@dominio.it" value={form.email} onChange={set("email")} />
                </Field>
                <Field label="Recapito telefonico diretto">
                  <input data-testid="contact-input-phone" type="text" className={inputCls} placeholder="Recapito per contatto" value={form.phone} onChange={set("phone")} />
                </Field>
              </div>
              <Field label="Oggetto della richiesta o descrizione lavori *">
                <textarea data-testid="contact-input-message" rows={4} required minLength={10} className={inputCls} placeholder="Indica dettagli del cantiere, tempistiche previste o tipologia di gara..." value={form.message} onChange={set("message")} />
              </Field>
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-2">
                <span className="text-[11px] text-slate-400 font-mono">
                  Riscontro garantito entro il giorno lavorativo successivo. Inviando accetti l'
                  <a href="/privacy" className="text-blue-400 hover:underline">informativa privacy</a>.
                </span>
                <button type="submit" disabled={sending} data-testid="contact-submit-button" className="w-full sm:w-auto px-8 py-4 bg-blue-600 hover:bg-blue-500 text-white font-bold uppercase tracking-widest text-xs transition-colors shadow-md disabled:opacity-60 inline-flex items-center justify-center gap-2">
                  {sending && <Loader2 className="animate-spin" size={14} />}
                  {sending ? "Invio in corso..." : "Invia Dati & Richiesta"}
                </button>
              </div>
            </form>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
